import { Control } from 'ol/Control'

export class ScaleControl extends Control {
  intervalListener = null;
  intervalListenerTime = 500;
  element = null;

  constructor(opt_options) {
    const options = opt_options || {};

    const firstLabel = document.createElement('span');
    firstLabel.innerHTML = '1:1';

    const middleLabel = document.createElement('span');
    middleLabel.innerHTML = '|';

    const updatedLabel = document.createElement('span');
    updatedLabel.innerHTML = '1';

    const innerElement = document.createElement('div');
    innerElement.className = 'ol-scale-inner';
    innerElement.appendChild(firstLabel);
    innerElement.appendChild(middleLabel);
    innerElement.appendChild(updatedLabel);

    const element = document.createElement('div');
    element.className = 'ol-scale ol-unselectable';
    element.appendChild(innerElement);

    super({
      element: element,
      target: options.target,
    });

    this.element = element;

    this.intervalListener = setInterval(this.waitMapReadyState.bind(this), this.intervalListenerTime);
  }

  waitMapReadyState() {
    if (this.getMap() !== null && document.querySelector('.ol-scale-bar-hidden .ol-scale-text') != null) this.init();
  }

  init() {
    let o_map = this.getMap();

    o_map.on('postrender', () => {
      this.updateCurrentScale();
    })

    this.updateCurrentScale();

    clearInterval(this.intervalListener);
  }

  updateCurrentScale() {
    this.element.querySelector('.ol-scale-inner span:first-child').innerHTML = `1 : ${this.getCurrentScale()}`;
    this.element.querySelector('.ol-scale-inner span:last-child').innerHTML = this.getCurrentZoom();
  }

  getCurrentScale() {
    let s_scale_text = document.querySelector('.ol-scale-bar-hidden .ol-scale-text').innerHTML;

    return parseFloat(s_scale_text.split(' : ')[1].replaceAll(',', ''));
  }

  getCurrentZoom() {
    return this.getMap().getView().getZoom().toFixed(2);
  }
}
